/* eslint-disable unicorn/filename-case */
import * as React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  description: string;
  image: string;
  url: string;
  keywords?: string;
  lang?: string;
}
const SEO: React.FC<SEOProps> = ({
  title,
  description,
  image,
  url,
  keywords = "Character table",
  lang = "en",
}) => {
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
